import { setupHiddenLinkText } from './hidden-link-text';
import { setupHintedInputs } from './hinted-input';
import { setupLazyLoad } from './lazy-load';
import { setupMenu } from './menu';
import { setupSiteInit } from './site-init';
import { setupSiteSearch } from './site-search';
import { setupStopReferrerHack } from './stop-referrer-hack';
import { setupToggles } from './toggles';

export function setup() {
  setupStopReferrerHack();
  setupSiteInit();
  setupToggles();
  setupLazyLoad();
  setupHiddenLinkText();
  setupMenu();
  setupSiteSearch();
  setupHintedInputs();
}
